import { Typography } from '@lightbeamai/design-system'
import React from 'react'
import { useIntl } from 'react-intl'

export const RiskDensityTooltipText = () => {
  const intl = useIntl()
  return (
    <div className="xs-p-8 risk-score-tooltip-text-container">
      <Typography type={'strong'} className="xs-mb-8" color="white" variant={'baseMinus2'}>
        {intl.formatMessage({ id: 'dataSources.widget.riskScoreDensity.tooltip.title' })}
      </Typography>
      <Typography color="white" variant={'baseMinus2'} className="xs-p-0">
        {intl.formatMessage({ id: 'dataSources.widget.riskScoreDensity.tooltip.body' })}
      </Typography>
      <Typography color="white" variant={'baseMinus2'} as="div">
        {intl.formatMessage({ id: 'risk.low' })} : &lt; 10%{' '}
      </Typography>
      <Typography color="white" variant={'baseMinus2'} as="div">
        {intl.formatMessage({ id: 'risk.average' })} 10 - 40%{' '}
      </Typography>
      <Typography color="white" variant={'baseMinus2'} as="div">
        {intl.formatMessage({ id: 'risk.high' })} &gt; 40%
      </Typography>
    </div>
  )
}
